import { Routes } from '@angular/router';
import { AuthGuardService } from './insti/auth-guard.service';

import { FullComponent } from './layouts/full/full.component';
import { AppBlankComponent } from './layouts/blank/blank.component';

export const AppRoutes: Routes = [
  {
    path: '',
    component: FullComponent,
    children: [
      // {
      //   path: '',
      //    redirectTo: '/natureza51/orcamento',
      //  // redirectTo: '/dashboards/dashboard1',
      //   pathMatch: 'full'
      // },
      {
        path: '',
        //  redirectTo: '/natureza51/orcamento',
       redirectTo: '/natureza51/dashboard-gestor',
        pathMatch: 'full'
      },
      { 
        path: 'natureza51',
        loadChildren: './natureza51/natureza51.module#Natureza51Module',
        canActivate: [AuthGuardService]
      },
      {
        path: 'dashboards',
        loadChildren: './dashboards/dashboards.module#DashboardsModule',
        // canActivate: [AuthGuardService]  
      },
      {
        path: 'dashboard-gestor',
        // loadChildren: '/natureza51/dashboard/dashboard-gestor',
        loadChildren: './natureza51/natureza51.module#Natureza51Module',
        // canActivate: [AuthGuardService]  
      }
    ]
  },
  {
    path: '',
    component: AppBlankComponent,
    children: [
      {
        path: 'insti',
        loadChildren: './insti/insti.module#InstiModule'
      }
    ]
  },
  {
    path: '',
    component: AppBlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren:
          './authentication/authentication.module#AuthenticationModule'
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'authentication/404'
  }
];
